import { ToastType } from 'ui'
import { useTranslation } from 'react-i18next'
import { useToast } from '../contexts'

export const useCommonApiErrorMessage = () => {
  const { t } = useTranslation()
  const toastManager = useToast()

  const checkForCommonErrorMessage = (
    response: any,
    fallbackMessage: string,
  ) => {
    if (
      response.status === 400 &&
      response.body.errors === 'User already exists'
    ) {
      toastManager.showToast(
        ToastType.Danger,
        t('Hay una cuenta registrada con este correo electrónico.'),
      )
    } else if (
      response.status === 400 &&
      response.body.password?.includes(
        'This password is too short. It must contain at least 8 characters.',
      )
    ) {
      toastManager.showToast(
        ToastType.Danger,
        t(
          'La contraseña es demasiado corta. Debe contener al menos 8 caracteres.',
        ),
      )
    } else if (
      response.status === 400 &&
      response.body.password?.includes('This password is too common.')
    ) {
      toastManager.showToast(
        ToastType.Danger,
        t('Esta contraseña es demasiado común.'),
      )
    } else if (
      response.status === 400 &&
      response.body.password?.includes('This password is entirely numeric.')
    ) {
      toastManager.showToast(
        ToastType.Danger,
        t(
          'Esta contraseña es completamente numérica. Añade al menos una letra.',
        ),
      )
    } else if (
      response.status === 400 &&
      response.body.errors === 'Ignore Word already exists'
    ) {
      toastManager.showToast(
        ToastType.Danger,
        t('La palabra que intentas añadir ya existe en tu vocabulario.'),
      )
    } else if (
      response.status === 401 &&
      response.body.code === 'token_not_valid'
    ) {
      toastManager.showToast(
        ToastType.Danger,
        t('Tu session ha expirado. Por favor, inicia sesión de nuevo.'),
      )
    } else if (
      response.status === 400 &&
      response.body.email?.includes(
        "We couldn't find an account associated with that email. Please try a different e-mail address.",
      )
    ) {
      toastManager.showToast(
        ToastType.Danger,
        t(
          'No pudimos encontrar una cuenta asociada con este email. Pruebe con un email diferente.',
        ),
      )
    } else if (
      response.status === 400 &&
      response.body.password?.includes(
        'The password is too similar to the username.',
      )
    ) {
      toastManager.showToast(
        ToastType.Danger,
        t(
          'La contraseña es demasiado similar al nombre de usuario. Pruebe con una contraseña diferente.',
        ),
      )
    } else {
      toastManager.showToast(ToastType.Danger, fallbackMessage)
      throw new Error(JSON.stringify(response))
    }
  }

  return { checkForCommonErrorMessage }
}
